import React from 'react';

import _get from 'lodash/get';

import {
  StoreStatus as StoreStatusIcon,
  StoreStatusPreOrder as StoreStatusPreOrderIcon,
} from '../components/icons';
import { PickupLocationType } from '../core/api/store/store.types';
import { AsyncMap } from '../core/types/data.types';
import * as Api from '../weborder/Api';

const checkIsTableServiceOnly = (
  collectionRestaurant: Api.CollectionRestaurantSummary,
): boolean => {
  if (!collectionRestaurant.PickupLocationTypes) {
    return false;
  }

  const hasTableService = collectionRestaurant.PickupLocationTypes.some(
    (pickupLocation) => pickupLocation === PickupLocationType.TableService,
  );
  const isTableServiceOnly =
    collectionRestaurant.PickupLocationTypes.length === 1 && hasTableService;

  return isTableServiceOnly;
};

const isRestaurantClosedWithNoPreOrders = (
  acceptPreOrders: boolean,
  isOpen: boolean,
): boolean => !isOpen && !acceptPreOrders;

const renderAvailabilityStatusIcon = (
  acceptPreOrders: boolean,
  isOpen: boolean,
): JSX.Element => {
  if (isOpen) {
    return <StoreStatusIcon testId="open-icon" status="open" size="xs" />;
  }

  if (isRestaurantClosedWithNoPreOrders(acceptPreOrders, isOpen)) {
    return <StoreStatusIcon testId="close-icon" status="closed" size="xs" />;
  }

  return <StoreStatusPreOrderIcon testId="preorder-icon" size="xs" />;
};

const getRestaurantPhoneNumber = (
  restaurantId: number | undefined,
  restaurantList: AsyncMap<Api.CollectionRestaurantDetail>,
): string => {
  const restaurant = _get(restaurantList, restaurantId);

  if (restaurant && restaurant.status === 'success') {
    return restaurant.data.PhoneNumber;
  }
  return '';
};

export const storeListUtils = {
  checkIsTableServiceOnly,
  getRestaurantPhoneNumber,
  isRestaurantClosedWithNoPreOrders,
  renderAvailabilityStatusIcon,
};
